import React from 'react';
import type { CortesPresetId } from '@/lib/layouts/types';

const shell = 'h-[52px] w-full rounded overflow-hidden bg-black/60 mb-1.5 relative';

export const CortesPickerIcon: React.FC<{ preset: CortesPresetId }> = ({ preset }) => {
  switch (preset) {
    case 'caixa-vermelha':
      return (
        <div className={`${shell} relative`}>
          <div className="absolute inset-0 bg-white/10" />
          <div className="absolute left-[4%] top-[6%] h-[9px] w-[42%] rounded-sm bg-white/30" />
          <div className="absolute right-[4%] top-[6%] h-[9px] w-[42%] rounded-sm bg-white/30" />
          <div className="absolute left-[18%] right-[18%] top-[42%] h-[8px] rounded-sm bg-red-500/80" />
          <div className="absolute left-[4%] bottom-[6%] h-[9px] w-[42%] rounded-sm bg-white/30" />
          <div className="absolute right-[4%] bottom-[6%] h-[9px] w-[42%] rounded-sm bg-white/30" />
        </div>
      );
    case 'barra-branca':
      return (
        <div className={shell}>
          <div className="absolute inset-0 bg-white/10" />
          <div className="absolute left-[6%] right-[6%] top-[18%] h-[8px] rounded-sm bg-white" />
        </div>
      );
  }
};
